/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssignVariables = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m4.185 3 1.742.972c-.05.091-.149.29-.28.587-.224.509-.45 1.099-.661 1.763-1.455 4.573-1.455 9.673.969 14.815L4.157 22C1.492 16.347 1.492 10.731 3.091 5.708 3.493 4.442 3.9 3.518 4.185 3zm15.67.007c.279.52.679 1.444 1.074 2.71 1.57 5.026 1.57 10.637-1.048 16.277l-1.802-.852c2.382-5.134 2.382-10.239.952-14.821a17.888 17.888 0 0 0-.65-1.767 8.766 8.766 0 0 0-.276-.59zm-5.188 5.31 3.69 3.724-3.69 3.724-1.407-1.42 1.285-1.299H6.006v-2.01l8.54.001-1.286-1.3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAssignVariables as AssignVariables };
